import ComponentResolver from "@components/component-resolver";
import { getSectioningContext } from "@components/component-resolver/sectionContext";
import Layout from "@components/layout";
import { getGlobals } from "@models/globals.model";
import { getModulePage, ModulePage } from "@models/module-page.model";
import { Sanity } from "@models/sanity.model";
import { NextPage } from "next";
import Head from "next/head";

interface ExperiencePageProps extends Sanity.PageProps {
  page: ModulePage | null;
}

const TheMirror: NextPage<ExperiencePageProps> = ({ globals, page }) => {
  if (!page) return <Head><meta httpEquiv="refresh" content="0; url=/" /></Head>;
  const { hide_header_banner, marketing_modules, seo, transparent_header } = page;

  return (
    <Layout
      globals={globals}
      pageID={page?.slug?.current}
      hideBanner={hide_header_banner}
      transparentHeader={transparent_header}
      seo={seo}>
      {marketing_modules?.length > 0 &&
        marketing_modules.map((schema: Sanity.Document, i: number) => {
          const sectioningContext = getSectioningContext({ modules: marketing_modules, index: i });
          return (
            <ComponentResolver
              key={`${schema._type}_${i}`}
              schema={schema}
              sectioningContext={sectioningContext}
            />
          );
        })}
    </Layout>
  );
};

export default TheMirror;

export async function getStaticProps() {
  const [globals, page] = await Promise.all([
    await getGlobals(),
    await getModulePage("experience"),
  ]);

  return {
    props: {
      globals,
      page: page || null,
    },
  };
}
